
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/contacto",
      function () {
        return require("private-next-pages/es-co/contacto/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/contacto"])
      });
    }
  